import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import { useSmartAllocationCustomizationContext } from './Context';

const SmartAllocationCustomization = (props) => {
  const { smartAllocCustCollection, initializingError, isInitializing } = useSmartAllocationCustomizationContext();

  return (
    <DataContainer
      component={Content}
      componentProps={{
        collection: smartAllocCustCollection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

export default SmartAllocationCustomization;
